/* eslint-disable */
import store from '../../../store/store';

function googleAddressAutoComplete(element, currentRoute, formDataName = 'formdata') {
  /**
   * The geocoder does its best to find locations based on USA ZIP codes, but there are ZIP code
   * values that do not work by themselves, such as 60006. Therefore, we append the search with
   * the country code "USA" to narrow the search to USA. However, there is no guarantee that the
   * geocoder will return the desired location.
   *
   * Refer to documentation at https://developers.google.com/maps/documentation/geocoding/intro .
   */
  var geocoder = new google.maps.Geocoder(),
    lat = 0,
    lng = 0,
    country_code = 'USA', // TODO: Use config values
    addressValuesMap = getValuesMap(currentRoute),
    zip_code_element = document.getElementById(addressValuesMap.postal_code),
    zip_code = (zip_code_element ? zip_code_element.value : '0'), // TODO: Use Vuex store
    postalStateEl = document.getElementById(addressValuesMap.administrative_area_level_1);

    store.postalState = (addressValuesMap.locationBias && postalStateEl ? postalStateEl.value : ''); // Used to prefix the search
    store.dispatch('setAddressError', false); // Reset to false

  geocoder.geocode({'address': `${zip_code} ${country_code}`}, function(results, status) {
    if (status === 'OK') {
      lat = results[0].geometry.location.lat();
      lng = results[0].geometry.location.lng();
    } else {
      window.console.info('Unable to retrieve lat/lng for this ZIP code. Using default of 0 (center of USA).');
      gtag('event', 'exception', {
        description: 'Failed lat/lng for ZIP',
        fatal: false, // set to true if the error is fatal
      });
    }

      var addressValuesMap = getValuesMap(currentRoute),
        autocomplete_location_field,
        center = new google.maps.LatLng(lat, lng),
        circle = new google.maps.Circle({
            center: center,
            radius: 10000, // TODO: Use config values
        });
  
      if (addressValuesMap && element.$refs[element[formDataName].field_name]) {
        autocomplete_location_field = new google.maps.places.Autocomplete(
          (document.getElementById('actualSearchInputField')), // TODO: Use config values
          {types: ['geocode']},
        );
        
        autocomplete_location_field.setBounds(circle.getBounds());
        autocomplete_location_field.setComponentRestrictions({country: "US"});
      
        autocomplete_location_field.addListener('place_changed', () => {
    
          let postal_street_number,
            postal_route,
            postal_city,
            postal_county,
            postal_state,
            postal_zip,
            addressValuesMap = getValuesMap(currentRoute),
            place = autocomplete_location_field.getPlace();

            store.dispatch('setAddressError', false); // Reset to false
      
          for (let i = 0; i < place.address_components.length; i++) {
      
            let addressType = place.address_components[i].types[0];
            switch (addressType) {
              case 'street_number':
                postal_street_number = place.address_components[i].long_name;
                break;
              case 'route':
                postal_route = place.address_components[i].long_name;
                break;
              case 'postal_code':
                postal_zip = place.address_components[i].long_name;
                break;
              case 'locality':
                postal_city = place.address_components[i].long_name;
              break;
              case 'administrative_area_level_2':
              {
                postal_county = place.address_components[i].short_name;
                postal_county =postal_county.substring(0, postal_county.lastIndexOf(" "))
              }
              break;
              case 'administrative_area_level_1':
                postal_state = place.address_components[i].short_name;
              break;
            }
          }
    
          let location_indices = [];
          // Get the indices of each field because they have to be referenced by their numerical index
          for (let i = 0; i < store.mutatable_data.length; i++) {
             location_indices[store.mutatable_data[i].field_name] = i;
          }
          // Regardless of what the user enters, do not change state value on Name Insured.
          // Selecting an out-of-state displays an error and does not change any values.
          if(
            currentRoute.path &&
            currentRoute.path.indexOf('/name-insured') !== -1 && // TODO: Use config values or route meta values
            store.mutatable_data[location_indices[addressValuesMap.administrative_area_level_1]].field_value !== postal_state) {
            window.console.warn('An address outside of the chosen state was selected for Named Insured and is not allowed.');
            gtag('event', 'exception', {
              description: 'Out-of-state address selected for Named Insured',
              fatal: false, // set to true if the error is fatal
            });

            store.dispatch('setAddressError', '<b>Out-of-State Address</b>: The address must match the selected state.');
            return; // Do not update any of the input values
          }

          // If any of the selected address's values do not exist, then show the warning message
          if (
            typeof postal_street_number === 'undefined' ||
            typeof postal_route === 'undefined' ||
            typeof postal_zip === 'undefined' ||
            typeof postal_city === 'undefined' ||
            typeof postal_county === 'undefined' ||
            typeof postal_state === 'undefined'
          ) {
            window.console.warn('An address with at least one undefined value was selected. The user must manually enter the address.');
            gtag('event', 'exception', {
              description: 'Incomplete address selected',
              fatal: false, // set to true if the error is fatal
            });

            // TODO: Research whether incomplete addresses should inform the user of such
            // store.dispatch('setAddressError', '<b>Invalid Address</b>: Please manually enter the address.');
          }

          // TODO: Use config values
          if (typeof postal_street_number !== 'undefined' && typeof postal_route !== 'undefined') {
            store.mutatable_data[location_indices[addressValuesMap.street_number_route]].field_value = postal_street_number + ' ' + postal_route;
          }

          if (typeof postal_zip !== 'undefined') {
            store.mutatable_data[location_indices[addressValuesMap.postal_code]].field_value = postal_zip;  
          }

          if (typeof postal_city !== 'undefined') {
            store.mutatable_data[location_indices[addressValuesMap.locality]].field_value = postal_city;
          }
          if (typeof postal_county !== 'undefined') {
            store.mutatable_data[location_indices[addressValuesMap.administrative_area_level_2]].field_value = postal_county;
          }
          if (typeof postal_state !== 'undefined') {
            store.mutatable_data[location_indices[addressValuesMap.administrative_area_level_1]].field_value = postal_state;
          }
        });
      }
  });
}

function getValuesMap(currentRoute) {
  switch (currentRoute.path) {
    case '/auto/name-insured':
    case '/nameinsured':
      return {
        locationBias: true,
        street_number_route:'QTE_ResidentialStreetAddress',
        postal_code:'QTE_ResidenceZip',
        locality:'QTE_ResidenceCity',
        administrative_area_level_2:'QTE_ResidenceCounty',
        administrative_area_level_1:'QTE_State',
      };
      break;
      
    case '/auto/prior-insurance':
    case '/priorinsurance':
      return {
        street_number_route:'QTE_PriorResidenceAddress',
        postal_code:'QTE_PriorResidenceZip',
        locality:'QTE_PriorResidenceCity',
        administrative_area_level_1:'QTE_PriorResidenceState',
      };
      break;

    case '/auto/rc2-contact-details':
    case '/rc2contactdetails':
      return {
        street_number_route:'QTE_MailStreetAddress',
        postal_code:'QTE_MailZip',
        locality:'QTE_MailCity',
        administrative_area_level_1:'QTE_MailState',
      };
      break;

    case '/checkout':
      return {
        street_number_route:'QTE_VehInspSiteStreetAdd',
        postal_code:'QTE_VehInspSiteZip',
        locality:'QTE_VehInspSiteCity',
        administrative_area_level_1:'QTE_VehInspSiteState',
      };
      break;

    case '/home/name-insured':
      return {
        street_number_route:'QTE_PRP_StreetAddress',
        postal_code:'QTE_PRP_ZipCode',
        locality:'QTE_PRP_City',
        administrative_area_level_2:'QTE_PRP_County',
        administrative_area_level_1:'QTE_PRP_State',
      };
      break;

    case '/condo/name-insured':
    return {
      street_number_route:'QTE_PRP_StreetAddress',
      postal_code:'QTE_PRP_ZipCode',
      locality:'QTE_PRP_City',
      administrative_area_level_2:'QTE_PRP_County',
      administrative_area_level_1:'QTE_PRP_State',
    };
    break;

    case '/renters/name-insured':
    return {
      street_number_route:'QTE_PRP_StreetAddress',
      postal_code:'QTE_PRP_ZipCode',
      locality:'QTE_PRP_City',
      administrative_area_level_2:'QTE_PRP_County',
      administrative_area_level_1:'QTE_PRP_State',
    };
    break;

    default:
      return {
        street_number_route:'QTE_ResidentialStreetAddress',
        postal_code:'QTE_ResidenceZip',
        locality:'QTE_ResidenceCity',
        administrative_area_level_2:'QTE_ResidenceCounty',
        administrative_area_level_1:'QTE_State',
      };
      break;

  }
  return null;
}

export { googleAddressAutoComplete };


// WEBPACK FOOTER //
// ./src/components/interview/shared/google-places-integration.js